import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-relogio-registrador',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './relogio-registrador.component.html',
  styleUrls: ['./relogio-registrador.component.css']
})
export class RelogioRegistradorComponent {
  @Input() agora = new Date();
  @Input() dataFormatada = '';
}
